import { computed, getCurrentInstance } from "@vue/composition-api";
import useAuthUser from "@/hooks/useAuthUser";
import { MUTATION_TYPES } from "@/store/const";
import { StateRoot } from "@/store/state";
import providers from "@/lib/api";
import { SUBSCRIPTION_LEVEL_FRAGMENT } from "@/const";

export default function useMySubscriptionLevels() {
  const vm = getCurrentInstance();
  const { authUser } = useAuthUser();

  const mySubscriptionLevels = computed(() =>
    vm ? ((vm.$store.state as StateRoot).mySubscriptionLevels ?? null) : null
  );

  const getMySubscriptionLevels = async (forceUpdate = false) => {
    if (!authUser.value || (!forceUpdate && mySubscriptionLevels.value !== null)) return;
    const response = await providers.SubscriptionLevelProvider.find(
      { userIds: [authUser.value.id] },
      SUBSCRIPTION_LEVEL_FRAGMENT
    );
    vm?.$store.commit(MUTATION_TYPES.SET_MY_SUBSCRIPTION_LEVELS, response);
  };

  return { mySubscriptionLevels, getMySubscriptionLevels };
}
